jQuery(function($){
    $(document.body).on('added_to_cart', function(event, fragments, cart_hash, $button){
        const productId = $button.data('product_id');

        const data = {
            action: 'lwm_is_bogo_valid',
            productId: productId
        };

        $.post('/wp-admin/admin-ajax.php', data, function(response){
            console.log(response);
            const responseJson = JSON.parse(response);
            console.log(responseJson);

            if(responseJson.valid_track == 'true') {
                // Simple popup
                alert("You qualify for a FREE second track! Add another set of full tracks to your cart for FREE!");
            }
        });
    });

    if($('body').hasClass('woocommerce-checkout') && $('.wc-block-checkout__terms .wc-block-components-checkbox__label').length) {
        const data = {
            action: 'lwm_maybe_disable_checkout_checkbox_ajax',
        };
        console.log(data);

        const checkbox = $('.wc-block-checkout__terms .wc-block-components-checkbox__label');
        console.log(checkbox);

        $.post('/wp-admin/admin-ajax.php', data, function(response){
            console.log(response);
            const responseJson = JSON.parse(response);
            console.log(responseJson);

            if(responseJson.disable) {
                console.log('hide box');
            } else {
                checkbox.after('<label for="bogo-confirm"><input type="checkbox" id="bogo-confirm"> ' + responseJson.checkbox_text + '</label>').hide();
                console.log('show box');
            }
        });

        $('.wc-block-checkout__form .wc-block-components-checkout-place-order-button').on('click', function(e){
            if($('#bogo-confirm').length) {
                const isBogoChecked = $('#bogo-confirm').prop('checked');
                console.log(isBogoChecked);
                if(isBogoChecked) {
                    //Do nothing
                } else {
                    e.preventDefault();
                    e.stopPropagation();
                    window.alert('Please check the BOGO consent checkbox to continue.');
                    $('#bogo-confirm').focus();
                }
            }
        });

    }
});